// Wholesale shop:
// - Per-row qty stepper, variant select (swaps price + product image), add-to-cart
// - Live cart preview at top of catalog (sourced from /cart.js)
// - Header cart count sync after every add / remove
// - Gate redirect for non-approved customers
//
// State lives per-row; cart preview re-renders from /cart.js after every mutation.

(function () {
  var BULK_GRAMS = 2267; // 5 lb; same constant as blendin-cart-minimum.js

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function formatMoneyShort(cents) {
    // $19 instead of $19.00, but keep real cents ($28.50)
    return formatMoney(cents).replace(/\.00$/, '');
  }

  // Minimum-order rule: a cart containing wholesale items must hold at least
  // one bulk (5 lb) bag OR at least `minBags` retail-size bags.
  function checkMinimum(cart, minBags) {
    var hasWholesale = false;
    var hasBulk = false;
    var retailCount = 0;
    ((cart && cart.items) || []).forEach(function (item) {
      if (item.product_type !== 'Coffee Wholesale') return;
      hasWholesale = true;
      if (item.grams >= BULK_GRAMS) hasBulk = true;
      else retailCount += item.quantity;
    });
    return {
      met: !hasWholesale || hasBulk || retailCount >= minBags,
      retailCount: retailCount,
      needed: Math.max(0, minBags - retailCount)
    };
  }

  function renderMinimumNotice(cart) {
    var wrap = document.querySelector('[data-bic-wholesale-cart]');
    var notice = document.querySelector('[data-bic-wholesale-min]');
    var viewLink = document.querySelector('[data-bic-wholesale-cart-view]');
    if (!wrap || !notice) return;

    var minBags = parseInt(wrap.dataset.minBags, 10) || 5;
    var state = checkMinimum(cart, minBags);

    if (state.met || !cart || cart.item_count === 0) {
      notice.hidden = true;
      notice.textContent = '';
      if (viewLink) viewLink.classList.remove('is-muted');
    } else {
      notice.hidden = false;
      notice.textContent =
        'Minimum order: one 5 lb bag or ' + minBags + ' retail bags. ' +
        'Add ' + state.needed + ' more retail bag' + (state.needed === 1 ? '' : 's') + ', or a 5 lb bag.';
      if (viewLink) viewLink.classList.add('is-muted');
    }
  }

  function syncHeaderCount(itemCount) {
    document.querySelectorAll('.bic-header__cart-count').forEach(function (el) {
      el.textContent = itemCount;
      if (el.classList.contains('bic-header__cart-badge')) {
        el.classList.toggle('is-empty', itemCount === 0);
      }
    });
  }

  function renderCartPreview(cart) {
    var wrap = document.querySelector('[data-bic-wholesale-cart]');
    var list = document.querySelector('[data-bic-wholesale-cart-list]');
    var totalEl = document.querySelector('[data-bic-wholesale-cart-total]');
    if (!wrap || !list || !totalEl) return;

    if (!cart || cart.item_count === 0) {
      wrap.hidden = true;
      list.innerHTML = '';
      totalEl.textContent = '$0.00';
      renderMinimumNotice(cart);
      return;
    }

    wrap.hidden = false;
    totalEl.textContent = formatMoney(cart.total_price);
    renderMinimumNotice(cart);

    var html = cart.items.map(function (item) {
      var img = item.image ? '<img src="' + item.image + '" alt="" loading="lazy" width="48" height="48">' : '';
      var line = formatMoney(item.final_line_price);
      var name = item.product_title || item.title;
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<span class="bic-wholesale-cart__variant"> · ' + item.variant_title + '</span>'
        : '';
      return (
        '<div class="bic-wholesale-cart__row" data-line-key="' + item.key + '">' +
          '<div class="bic-wholesale-cart__media">' + img + '</div>' +
          '<div class="bic-wholesale-cart__name">' +
            '<span class="bic-serif">' + name + '</span>' +
            variant +
          '</div>' +
          '<div class="bic-wholesale-cart__qty bic-qty-mini" role="group" aria-label="Cart line quantity">' +
            '<button type="button" class="bic-qty-mini-btn" data-cart-qty-action="dec" aria-label="Decrease quantity">−</button>' +
            '<span class="bic-qty-mini-display" data-cart-qty-display>' + item.quantity + '</span>' +
            '<button type="button" class="bic-qty-mini-btn" data-cart-qty-action="inc" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<div class="bic-wholesale-cart__price">' + line + '</div>' +
          '<button type="button" class="bic-wholesale-cart__remove" data-bic-wholesale-cart-remove aria-label="Remove ' + name + '">×</button>' +
        '</div>'
      );
    }).join('');

    list.innerHTML = html;
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        syncHeaderCount(cart.item_count);
        renderCartPreview(cart);
        return cart;
      })
      .catch(function () { /* no-op; non-fatal */ });
  }

  function changeLine(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: lineKey, quantity: Math.max(0, quantity) })
    })
      .then(function () { return refreshCart(); });
  }

  function bindCartPreviewEvents() {
    var list = document.querySelector('[data-bic-wholesale-cart-list]');
    if (!list) return;

    var inflight = false;

    list.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-bic-wholesale-cart-remove]');
      var qtyBtn = e.target.closest('[data-cart-qty-action]');
      var row;

      if (removeBtn) {
        row = removeBtn.closest('[data-line-key]');
        if (!row || inflight) return;
        inflight = true;
        removeBtn.disabled = true;
        changeLine(row.dataset.lineKey, 0).finally(function () { inflight = false; });
        return;
      }

      if (qtyBtn) {
        row = qtyBtn.closest('[data-line-key]');
        if (!row || inflight) return;
        var display = row.querySelector('[data-cart-qty-display]');
        var current = parseInt(display && display.textContent, 10) || 0;
        var next = qtyBtn.dataset.cartQtyAction === 'inc' ? current + 1 : current - 1;
        if (next < 0) next = 0;
        // Optimistic UI update; refreshCart() will re-render with the truth
        if (display) display.textContent = next;
        inflight = true;
        row.querySelectorAll('[data-cart-qty-action]').forEach(function (b) { b.disabled = true; });
        changeLine(row.dataset.lineKey, next).finally(function () { inflight = false; });
      }
    });
  }

  function initRow(row) {
    var qtyInput = row.querySelector('[data-qty-input]');
    var qtyDecBtn = row.querySelector('[data-qty-action="dec"]');
    var priceEl = row.querySelector('[data-line-price]');
    var addBtn = row.querySelector('[data-bic-wholesale-add]');
    var variantSelect = row.querySelector('[data-variant-select]');
    var variantHidden = row.querySelector('[data-variant-id]');
    var variantPriceHidden = row.querySelector('[data-variant-price]');
    var variantGramsHidden = row.querySelector('[data-variant-grams]');
    var imgEl = row.querySelector('[data-bic-wholesale-img]');
    var msrpLine = row.querySelector('[data-msrp-line]');
    // Money metafield prints as a plain amount ("19.0"); strip anything else defensively
    var msrpCents = Math.round((parseFloat(String(row.dataset.msrpAmount || '').replace(/[^0-9.]/g, '')) || 0) * 100);

    var state = {
      qty: 1,
      variantId: variantSelect ? variantSelect.value : (variantHidden ? variantHidden.value : ''),
      unitPrice: variantSelect
        ? parseInt(variantSelect.options[variantSelect.selectedIndex].dataset.price, 10) || 0
        : (variantPriceHidden ? parseInt(variantPriceHidden.value, 10) || 0 : 0)
    };

    function selectedGrams() {
      if (variantSelect) {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        return parseInt(opt && opt.dataset.grams, 10) || 0;
      }
      return variantGramsHidden ? parseInt(variantGramsHidden.value, 10) || 0 : 0;
    }

    // MSRP line: only for retail-size bags the shop can resell, never for 5 lb
    function refreshMsrp() {
      if (!msrpLine) return;
      var grams = selectedGrams();
      var profit = msrpCents - state.unitPrice;
      if (msrpCents > 0 && profit > 0 && grams > 0 && grams < BULK_GRAMS) {
        msrpLine.innerHTML =
          'Sugg. retail ' + formatMoneyShort(msrpCents) +
          '<span class="bic-wholesale-row__msrp-keep">you keep ' + formatMoney(profit) + ' per bag</span>';
        msrpLine.hidden = false;
      } else {
        msrpLine.hidden = true;
        msrpLine.textContent = '';
      }
    }

    // Rows open at quantity 1 and setQty clamps there, so an always-enabled
    // minus button makes the FIRST minus click on every row inert. Disable it
    // at the bound. Same fix as blendin-subscription.js (Clarity, 2026-08-11).
    // There is no upper bound here, so only the minus button is synced.
    function syncQtyButtons() {
      if (qtyDecBtn) qtyDecBtn.disabled = state.qty <= 1;
    }

    function setQty(n) {
      var clamped = Math.max(1, Math.floor(n));
      if (isNaN(clamped) || !isFinite(clamped)) clamped = 1;
      state.qty = clamped;
      if (qtyInput && parseInt(qtyInput.value, 10) !== clamped) qtyInput.value = clamped;
      refreshPrice();
      syncQtyButtons();
    }

    function refreshPrice() {
      if (priceEl) priceEl.textContent = formatMoney(state.unitPrice * state.qty);
    }

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        state.variantId = variantSelect.value;
        var opt = variantSelect.options[variantSelect.selectedIndex];
        state.unitPrice = parseInt(opt.dataset.price, 10) || 0;
        var newImg = opt.dataset.image;
        if (imgEl && newImg) imgEl.src = newImg;
        refreshPrice();
        refreshMsrp();
      });
    }

    refreshMsrp();
    syncQtyButtons();

    row.querySelectorAll('[data-qty-action]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var action = btn.dataset.qtyAction;
        if (action === 'inc') setQty(state.qty + 1);
        else if (action === 'dec') setQty(state.qty - 1);
      });
    });

    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        var v = parseInt(qtyInput.value, 10);
        // Allow the field to be empty mid-typing without snapping back
        if (qtyInput.value === '') return;
        setQty(v);
      });
      qtyInput.addEventListener('blur', function () {
        // Re-clamp on blur in case the field was left empty or invalid
        setQty(parseInt(qtyInput.value, 10));
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (!state.variantId) return;

        var originalLabel = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';

        var body = new URLSearchParams();
        body.append('id', state.variantId);
        body.append('quantity', String(state.qty));

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            'Accept': 'application/json'
          },
          body: body.toString()
        })
          .then(function (res) {
            return res.text().then(function (text) {
              var data = null;
              try { data = text ? JSON.parse(text) : null; } catch (_) { /* non-JSON response */ }
              return { ok: res.ok, status: res.status, data: data, text: text };
            });
          })
          .then(function (result) {
            if (!result.ok || !result.data) {
              if (typeof console !== 'undefined' && console.warn) {
                console.warn('[wholesale-shop] add-to-cart failed', result.status, result.text);
              }
              var msg;
              if (result.data && (result.data.description || result.data.message)) {
                msg = result.data.description || result.data.message;
              } else if (result.status === 422) {
                msg = 'Shopify rejected this item. It may be out of stock or unavailable in your shipping region.';
              } else if (result.status === 404) {
                msg = 'This product is no longer available.';
              } else {
                msg = 'We could not add this item. Please try again, or refresh the page.';
              }
              throw new Error(msg);
            }
            addBtn.textContent = 'Added';
            return refreshCart().then(function () {
              setTimeout(function () {
                addBtn.disabled = false;
                addBtn.textContent = originalLabel;
                setQty(1);
              }, 1400);
            });
          })
          .catch(function (err) {
            addBtn.disabled = false;
            addBtn.textContent = originalLabel;
            window.alert(err.message || 'Something went wrong. Please try again.');
          });
      });
    }
  }

  function bootList(list) {
    list.querySelectorAll('[data-bic-wholesale-row]').forEach(initRow);
  }

  function bootGate(gate) {
    var url = gate.dataset.bicWholesaleRedirect || '/pages/wholesale';
    setTimeout(function () { window.location.replace(url); }, 600);
  }

  function boot() {
    document.querySelectorAll('[data-bic-wholesale-list]').forEach(bootList);
    document.querySelectorAll('[data-bic-wholesale-redirect]').forEach(bootGate);
    bindCartPreviewEvents();
    if (document.querySelector('[data-bic-wholesale-cart]')) {
      refreshCart();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
